// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__IXVmp","right":"Footer_right__1tgTb","buttons":"Footer_buttons__AAJ-_"};